module.exports = __webpack_public_path__ + "static/media/folder.c044d5db.svg";